import React, { useEffect, useState, useCallback } from 'react';

import InputWrapper from 'components/inputWrapper';

import emailValidator from './validator';
import TextField from '../../stateless/textField';

import { noop } from 'helpers';

const EmailField = ({
  value,
  errorMessage,
  errorKey = 'email',
  setErrors = noop,
  required,
  description,
  ...rest
}) => {

  const [state, setState] = useState({
    showError: false,
    isFocused: false,
  });

  const validate = useCallback(val => {
    const showError = !emailValidator(val);

    setState(prev => ({ ...prev, showError }));
    setErrors(showError, errorKey);
  }, [setErrors, errorKey]);

  const focusedEmailStateHandler = () => {
    setState(prev => ({ ...prev, isFocused: prev.showError }));
  };

  useEffect(() => {
    !!value && validate(value);
  }, [validate, value]);

  return (
    <InputWrapper
      label="Email"
      hint={description}
      required={required}
      showError={!!(state.showError || errorMessage)}
      errorMessage={(state.showError && 'Email is not valid') || errorMessage}
    >
      <TextField
        onBlur={focusedEmailStateHandler}
        value={value}
        placeholder="Email"
        {...rest}
      />
    </InputWrapper>
  );
};

export default EmailField;
